import { call, put, takeEvery } from 'redux-saga/effects';
import { departingSoonActionCreators, IDepartingSoonApiResponse } from '..';
import { httpService } from '../../..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { ApiUrls } from '../../ApiUrls';
import { executeApiRequest } from '../../asyncUtils';
import { inventoryActionCreators } from '../../inventory';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { IDepartingSoonFetchRequest } from '../departingSoonInterfaces';

function* fetchDepartingSoonSaga(action: ReturnType<typeof departingSoonActionCreators.fetch>) {
  if (action.payload.showSpinner) {
    yield put(uiActionCreators.toggleLoading('departingSoonReport'));
  }
  const response: IApiExecuteRespone<IDepartingSoonApiResponse> = yield call(fetchDepartingSoon, action.payload);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(departingSoonActionCreators.setItems(response.value.items));
    yield put(inventoryActionCreators.set(response.value.inventoryHash));
  }

  if (action.payload.showSpinner) {
    yield put(uiActionCreators.toggleLoading('departingSoonReport'));
  }
}

export function* watchFetchDepartingSoon() {
  yield takeEvery(departingSoonActionCreators.fetch.match, fetchDepartingSoonSaga);
}

export async function fetchDepartingSoon({
  date,
  loadNumber,
  shipmentId
}: IDepartingSoonFetchRequest): Promise<IApiExecuteRespone<IDepartingSoonApiResponse>> {
  let dateString = '';
  if (date) {
    dateString = typeof date === 'string' ? date : new Date(date).toISOString();
  }
  return executeApiRequest(() => httpService.get(ApiUrls.departingSoon({ date: dateString, loadNumber, shipmentId })));
}
